<template >
    <div>
        <v-layout row justify-center>
            <v-dialog v-model="dialog" hide-overlay class="ma-0" persistent transition="dialog-bottom-transition"
                content-class="elevation-3">
                <v-card class="pa-0 ma-0" style="height: 200px;">

                    <v-toolbar dark color="primary">
                        <v-btn icon dark @click="chiudiDialog()">
                            <v-icon>close</v-icon>
                        </v-btn>
                        <v-spacer></v-spacer>
                        <v-toolbar-title>Ubicazioni</v-toolbar-title>
                    </v-toolbar>


                    <v-card-text class="pt-2">
                        <table style="border-collapse: collapse;">
                            <tr style="border-bottom: 1px solid black; text-align: left; height: 30px;">
                                <th style="width: 100px;">Tipo</th>
                                <th style="width: 200px;">Ubicazione</th>
                                <th>Qta</th>
                            </tr>
                            <tr style="height: 30px;">
                                <td>SEDE</td>
                                <td>{{ datiEsistenze.ubicazione }}</td>
                                <td>{{ datiEsistenze.qtaUbicazione1 }}</td>
                            </tr>
                            <tr style="height: 30px;">
                                <td style="font-weight: bold;">{{ datiEsistenze.ubicazione2 ? datiEsistenze.ubicazione2.toString().substring(0, 2) : ''
                                }}</td>
                                <td style="font-weight: bold;">{{ datiEsistenze.ubicazione2 }}</td>
                                <td style="font-weight: bold;">{{ datiEsistenze.qtaUbicazione2 }}</td>
                            </tr>
                        </table>

                    </v-card-text>
                </v-card>
            </v-dialog>
        </v-layout>
    </div>
</template>



<script>
import {
    get_ubicazioniEsistenze
} from "@/api/api.js";

export default {
    props: {
        dialog: { type: Boolean, required: true },
        dati: { type: Object },
    },
    data() {
        return {
            datiEsistenze: {},
            attesa: false
        };
    },

    methods: {
        async caricaDati() {
            if (!this.dialog) return;

            // Reset
            this.datiEsistenze = {}

            this.attesa = true

            try {
                let res = await get_ubicazioniEsistenze(this.dati.cdArticoloFiglio)
                this.datiEsistenze = res.data

            } catch (error) {
                console.log(this.$functions.getErrorMsg(error));
            }

            this.attesa = false
        },

        chiudiDialog() {
            this.$emit("chiudiDialogDettQta");
        },

    },



    watch: {
        dialog() {
            this.caricaDati();
        }
    }
};
</script>